import { render, staticRenderFns } from "./TeamMemberModal.vue?vue&type=template&id=6fce81b3"
import script from "./TeamMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports